"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.highlightText = void 0;
var markup_1 = require("./markup");
var getBoundaries_1 = require("./getBoundaries");
/**
 * Highlight `words` in `text.
 */
var highlightText = function (text, words) {
    if (words.length === 0) {
        return text;
    }
    var boundaries = getBoundaries_1.getBoundaries(text, words);
    return markup_1.markup(text, boundaries, '<mark>', '</mark>');
};
exports.highlightText = highlightText;
